import type { OnInit} from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { LoginError } from '../../../modules/login/services/login.service';

@Component({
    selector: 'ppl-login-container',
    templateUrl: './login-container.component.html',
    styleUrls: ['./login-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginContainerComponent implements OnInit {

  @Input() title: string;
  @Input() description?: string;
  @Input() error?: LoginError;
  @Input() error_str?: string;
  @Input() loading?: boolean;

  LoginError = LoginError;

  currentYear = new Date().getFullYear();

  errorInfo: { [key: string]: any };

  constructor() { }

  ngOnInit() {
    this.errorInfo = this.getErrorInfo();
  }

  getErrorInfo(): { [key: string]: any } {
    if (this.error_str) {
      try {
        return JSON.parse(this.error_str);
      } catch (err) {
        return {};
      }
    } else {
      return {};
    }
  }

}
